var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.permitAllowed)?_c('div',{class:_vm.classStr || '',attrs:{"data-permit":_vm.permitKey}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }